export interface SubCountyConfig {
  name: string;
  estates?: string[];
}

export interface Location {
  name: string;
  subcounties: SubCountyConfig[];
}

export const PRIORITY_COUNTY_NAMES = [
  'Nairobi', 'Kiambu', 'Nakuru', 'Mombasa', 'Kakamega', 'Kisumu', 'Bungoma', 'Meru',
  'Kilifi', 'Machakos', 'Kisii', 'Uasin Gishu', 'Murang\'a', 'Nyeri', 'Kajiado',
  'Kwale', 'Migori', 'Kericho', 'Siaya', 'Laikipia', 'Embu', 'Kirinyaga',
  'Trans Nzoia', 'Nandi', 'Makueni', 'Bomet', 'Nyandarua', 'Homa Bay', 'Vihiga',
  'Kitui', 'Taita Taveta', 'Busia', 'Tharaka Nithi', 'Elgeyo Marakwet', 'West Pokot',
  'Baringo', 'Narok', 'Samburu', 'Tana River', 'Lamu', 'Garissa', 'Wajir',
  'Mandera', 'Marsabit', 'Isiolo', 'Turkana', 'Pokot',
];

export const KENYA_COUNTIES: Location[] = [
  // Coast
  {
    name: 'Mombasa',
    subcounties: [
      { name: 'Changamwe' },
      { name: 'Jomvu' },
      { name: 'Kisauni' },
      { name: 'Nyali' },
      { name: 'Likoni' },
      { name: 'Mvita' }
    ]
  },
  {
    name: 'Kwale',
    subcounties: [
      { name: 'Msambweni' },
      { name: 'Lunga Lunga' },
      { name: 'Kwale Town' },
      { name: 'Kinango' },
      { name: 'Matuga' }
    ]
  },
  {
    name: 'Kilifi',
    subcounties: [
      { name: 'Kilifi North' },
      { name: 'Kilifi South' },
      { name: 'Kaloleni' },
      { name: 'Rabai' },
      { name: 'Ganze' },
      { name: 'Malindi' },
      { name: 'Magarini' }
    ]
  },
  {
    name: 'Tana River',
    subcounties: [{ name: 'Garsen' }, { name: 'Galole' }, { name: 'Bura' }]
  },
  {
    name: 'Lamu',
    subcounties: [{ name: 'Lamu East' }, { name: 'Lamu West' }]
  },
  {
    name: 'Taita Taveta',
    subcounties: [
      { name: 'Taveta' },
      { name: 'Wundanyi' },
      { name: 'Mwatate' },
      { name: 'Voi' }
    ]
  },

  // Northeastern
  {
    name: 'Garissa',
    subcounties: [
      { name: 'Garissa Township' },
      { name: 'Balambala' },
      { name: 'Lagdera' },
      { name: 'Dadaab' },
      { name: 'Fafi' },
      { name: 'Ijara' }
    ]
  },
  {
    name: 'Wajir',
    subcounties: [
      { name: 'Wajir North' },
      { name: 'Wajir East' },
      { name: 'Wajir South' },
      { name: 'Wajir West' },
      { name: 'Eldas' },
      { name: 'Tarbaj' }
    ]
  },
  {
    name: 'Mandera',
    subcounties: [
      { name: 'Mandera West' },
      { name: 'Mandera North' },
      { name: 'Mandera Central' },
      { name: 'Mandera East' },
      { name: 'Mandera South' },
      { name: 'Lafey' }
    ]
  },

  // Eastern
  {
    name: 'Marsabit',
    subcounties: [
      { name: 'Moyale' },
      { name: 'North Horr' },
      { name: 'Saku' },
      { name: 'Laisamis' }
    ]
  },
  {
    name: 'Isiolo',
    subcounties: [{ name: 'Isiolo North' }, { name: 'Isiolo South' }]
  },
  {
    name: 'Meru',
    subcounties: [
      { name: 'Igembe South' },
      { name: 'Igembe Central' },
      { name: 'Igembe North' },
      { name: 'Tigania West' },
      { name: 'Tigania East' },
      { name: 'North Imenti' },
      { name: 'Buuri' },
      { name: 'Central Imenti' },
      { name: 'South Imenti' }
    ]
  },
  {
    name: 'Tharaka-Nithi',
    subcounties: [
      { name: 'Maara' },
      { name: "Chuka/Igambang'ombe" },
      { name: 'Tharaka' }
    ]
  },
  {
    name: 'Embu',
    subcounties: [
      { name: 'Manyatta' },
      { name: 'Runyenjes' },
      { name: 'Mbeere North' },
      { name: 'Mbeere South' }
    ]
  },
  {
    name: 'Kitui',
    subcounties: [
      { name: 'Mwingi North' },
      { name: 'Mwingi West' },
      { name: 'Mwingi Central' },
      { name: 'Kitui West' },
      { name: 'Kitui Rural' },
      { name: 'Kitui Central' },
      { name: 'Kitui South' },
      { name: 'Kitui East' }
    ]
  },
  {
    name: 'Machakos',
    subcounties: [
      { name: 'Masinga' },
      { name: 'Yatta' },
      { name: 'Kangundo' },
      { name: 'Matungulu' },
      { name: 'Kathiani' },
      { name: 'Mavoko' },
      { name: 'Machakos Town' },
      { name: 'Mwala' }
    ]
  },
  {
    name: 'Makueni',
    subcounties: [
      { name: 'Mbooni' },
      { name: 'Kilome' },
      { name: 'Kaiti' },
      { name: 'Makueni' },
      { name: 'Kibwezi West' },
      { name: 'Kibwezi East' }
    ]
  },

  // Central
  {
    name: 'Nyandarua',
    subcounties: [
      { name: 'Kinangop' },
      { name: 'Kipipiri' },
      { name: 'Ol Kalou' },
      { name: 'Ol Joro Orok' },
      { name: 'Ndaragwa' }
    ]
  },
  {
    name: 'Nyeri',
    subcounties: [
      { name: 'Tetu' },
      { name: 'Kieni' },
      { name: 'Mathira' },
      { name: 'Othaya' },
      { name: 'Mukurweini' },
      { name: 'Nyeri Town' }
    ]
  },
  {
    name: 'Kirinyaga',
    subcounties: [
      { name: 'Mwea' },
      { name: 'Gichugu' },
      { name: 'Ndia' },
      { name: 'Kirinyaga Central' }
    ]
  },
  {
    name: "Murang'a",
    subcounties: [
      { name: 'Kangema' },
      { name: 'Mathioya' },
      { name: 'Kiharu' },
      { name: 'Kigumo' },
      { name: 'Maragua' },
      { name: 'Kandara' },
      { name: 'Gatanga' }
    ]
  },
  {
    name: 'Kiambu',
    subcounties: [
      { name: 'Gatundu South' },
      { name: 'Gatundu North' },
      { name: 'Githunguri' },
      { name: 'Kiambu Town' },
      { name: 'Kiambaa' },
      { name: 'Kabete' },
      { name: 'Kikuyu' },
      { name: 'Limuru' },
      { name: 'Lari' },
      { name: 'Thika Town' },
      { name: 'Ruiru' },
      { name: 'Juja' }
    ]
  },

  // Rift Valley North/Central
  {
    name: 'Turkana',
    subcounties: [
      { name: 'Turkana North' },
      { name: 'Turkana West' },
      { name: 'Turkana Central' },
      { name: 'Loima' },
      { name: 'Turkana South' },
      { name: 'Turkana East' }
    ]
  },
  {
    name: 'West Pokot',
    subcounties: [
      { name: 'Kapenguria' },
      { name: 'Sigor' },
      { name: 'Kacheliba' },
      { name: 'Pokot South' }
    ]
  },
  {
    name: 'Samburu',
    subcounties: [
      { name: 'Samburu West' },
      { name: 'Samburu North' },
      { name: 'Samburu East' }
    ]
  },
  {
    name: 'Trans Nzoia',
    subcounties: [
      { name: 'Kwanza' },
      { name: 'Endebess' },
      { name: 'Saboti' },
      { name: 'Kiminini' },
      { name: 'Cherangany' }
    ]
  },
  {
    name: 'Uasin Gishu',
    subcounties: [
      { name: 'Soy' },
      { name: 'Turbo' },
      { name: 'Moiben' },
      { name: 'Ainabkoi' },
      { name: 'Kapseret' },
      { name: 'Kesses' }
    ]
  },
  {
    name: 'Elgeyo Marakwet',
    subcounties: [
      { name: 'Marakwet East' },
      { name: 'Marakwet West' },
      { name: 'Keiyo North' },
      { name: 'Keiyo South' }
    ]
  },
  {
    name: 'Nandi',
    subcounties: [
      { name: 'Tinderet' },
      { name: 'Aldai' },
      { name: 'Nandi Hills' },
      { name: 'Chesumei' },
      { name: 'Emgwen' },
      { name: 'Mosop' }
    ]
  },
  {
    name: 'Baringo',
    subcounties: [
      { name: 'Tiaty' },
      { name: 'Baringo North' },
      { name: 'Baringo Central' },
      { name: 'Baringo South' },
      { name: 'Mogotio' },
      { name: 'Eldama Ravine' }
    ]
  },
  {
    name: 'Laikipia',
    subcounties: [
      { name: 'Laikipia West' },
      { name: 'Laikipia East' },
      { name: 'Laikipia North' }
    ]
  },

  // Rift Valley South
  {
    name: 'Nakuru',
    subcounties: [
      { name: 'Molo' },
      { name: 'Njoro' },
      { name: 'Naivasha' },
      { name: 'Gilgil' },
      { name: 'Kuresoi South' },
      { name: 'Kuresoi North' },
      { name: 'Subukia' },
      { name: 'Rongai' },
      { name: 'Bahati' },
      { name: 'Nakuru Town West' },
      { name: 'Nakuru Town East' }
    ]
  },
  {
    name: 'Narok',
    subcounties: [
      { name: 'Narok North' },
      { name: 'Narok South' },
      { name: 'Narok West' },
      { name: 'Narok East' },
      { name: 'Kilgoris' },
      { name: 'Emurua Dikirr' }
    ]
  },
  {
    name: 'Kajiado',
    subcounties: [
      { name: 'Kajiado Central' },
      { name: 'Kajiado North' },
      { name: 'Kajiado West' },
      { name: 'Kajiado East' },
      { name: 'Kajiado South' }
    ]
  },
  {
    name: 'Kericho',
    subcounties: [
      { name: 'Kipkelion East' },
      { name: 'Kipkelion West' },
      { name: 'Ainamoi' },
      { name: 'Belgut' },
      { name: 'Sigowet/Soin' },
      { name: 'Bureti' }
    ]
  },
  {
    name: 'Bomet',
    subcounties: [
      { name: 'Sotik' },
      { name: 'Chepalungu' },
      { name: 'Bomet East' },
      { name: 'Bomet Central' },
      { name: 'Konoin' }
    ]
  },

  // Western
  {
    name: 'Kakamega',
    subcounties: [
      { name: 'Lugari' },
      { name: 'Likuyani' },
      { name: 'Malava' },
      { name: 'Lurambi' },
      { name: 'Navakholo' },
      { name: 'Mumias West' },
      { name: 'Mumias East' },
      { name: 'Matungu' },
      { name: 'Butere' },
      { name: 'Khwisero' },
      { name: 'Shinyalu' },
      { name: 'Ikolomani' }
    ]
  },
  {
    name: 'Vihiga',
    subcounties: [
      { name: 'Vihiga' },
      { name: 'Sabatia' },
      { name: 'Hamisi' },
      { name: 'Luanda' },
      { name: 'Emuhaya' }
    ]
  },
  {
    name: 'Bungoma',
    subcounties: [
      { name: 'Mt. Elgon' },
      { name: 'Sirisia' },
      { name: 'Kabuchai' },
      { name: 'Bumula' },
      { name: 'Kanduyi' },
      { name: 'Webuye East' },
      { name: 'Webuye West' },
      { name: 'Kimilili' },
      { name: 'Tongaren' }
    ]
  },
  {
    name: 'Busia',
    subcounties: [
      { name: 'Teso North' },
      { name: 'Teso South' },
      { name: 'Nambale' },
      { name: 'Matayos' },
      { name: 'Butula' },
      { name: 'Funyula' },
      { name: 'Budalangi' }
    ]
  },

  // Nyanza
  {
    name: 'Siaya',
    subcounties: [
      { name: 'Ugenya' },
      { name: 'Ugunja' },
      { name: 'Alego Usonga' },
      { name: 'Gem' },
      { name: 'Bondo' },
      { name: 'Rarieda' }
    ]
  },
  {
    name: 'Kisumu',
    subcounties: [
      { name: 'Kisumu East' },
      { name: 'Kisumu West' },
      { name: 'Kisumu Central' },
      { name: 'Seme' },
      { name: 'Nyando' },
      { name: 'Muhoroni' },
      { name: 'Nyakach' }
    ]
  },
  {
    name: 'Homa Bay',
    subcounties: [
      { name: 'Kasipul' },
      { name: 'Kabondo Kasipul' },
      { name: 'Karachuonyo' },
      { name: 'Rangwe' },
      { name: 'Homa Bay Town' },
      { name: 'Ndhiwa' },
      { name: 'Suba North' },
      { name: 'Suba South' }
    ]
  },
  {
    name: 'Migori',
    subcounties: [
      { name: 'Rongo' },
      { name: 'Awendo' },
      { name: 'Suna East' },
      { name: 'Suna West' },
      { name: 'Uriri' },
      { name: 'Nyatike' },
      { name: 'Kuria West' },
      { name: 'Kuria East' }
    ]
  },
  {
    name: 'Kisii',
    subcounties: [
      { name: 'Bonchari' },
      { name: 'South Mugirango' },
      { name: 'Bomachoge Borabu' },
      { name: 'Bobasi' },
      { name: 'Bomachoge Chache' },
      { name: 'Nyaribari Masaba' },
      { name: 'Nyaribari Chache' },
      { name: 'Kitutu Chache North' },
      { name: 'Kitutu Chache South' }
    ]
  },
  {
    name: 'Nyamira',
    subcounties: [
      { name: 'Kitutu Masaba' },
      { name: 'West Mugirango' },
      { name: 'North Mugirango' },
      { name: 'Borabu' }
    ]
  },

  // Nairobi
  {
    name: 'Nairobi',
    subcounties: [
      { name: 'CBD / Town', estates: ['City Centre'] }, // Premium placement
      { name: 'Westlands', estates: ['Parklands', 'Kangemi', 'Mountain View', 'Kitisuru', 'Spring Valley', 'Loresho', 'Kyuna'] },
      { name: "Lang'ata", estates: ['Karen', "Lang'ata", 'Nyayo Highrise', 'Nairobi West', 'Mugumoini', 'Southlands'] },
      { name: 'Kasarani', estates: ['Mwiki', 'Zimmerman', 'Githurai 44', 'Githurai 45', 'Clay City', 'Hunters', 'Seasons'] },
      { name: 'Embakasi West', estates: ['Industrial Area', 'South B', 'South C', 'Mombasa Road', 'Mukuru Kwa Njenga', 'Mukuru Kwa Reuben', 'Nyayo Estate', 'Nairobi West'] },
      { name: 'Dagoretti North' },
      { name: 'Dagoretti South' },
      { name: 'Kibra' },
      { name: 'Ruaraka' },
      { name: 'Embakasi South' },
      { name: 'Embakasi North' },
      { name: 'Embakasi Central' },
      { name: 'Embakasi East' },
      { name: 'Makadara' },
      { name: 'Kamukunji' },
      { name: 'Starehe' },
      { name: 'Mathare' },
      { name: 'Roysambu' }
    ]
  }
];

export const getFlattenedLocations = (): string[] => {
  const locations = new Set<string>();
  
  KENYA_COUNTIES.forEach((county) => {
    locations.add(county.name);
    county.subcounties?.forEach((sub) => {
      locations.add(sub.name);
      sub.estates?.forEach((estate) => {
        locations.add(estate);
      });
    });
  });
  
  return Array.from(locations).sort();
};

export const SORTED_COUNTIES = [
  ...PRIORITY_COUNTY_NAMES
    .map(name => KENYA_COUNTIES.find(c => c.name === name))
    .filter((c): c is Location => c !== undefined),
  ...KENYA_COUNTIES.filter(c => !PRIORITY_COUNTY_NAMES.includes(c.name)),
];
